module.exports = __webpack_public_path__ + "media/hyper/fonts/Nunito-Light-c77d98f5cc70801b4f66c5e72890c116.svg";